import { Badge } from '@gogame/components';
import React from 'react';

export const AdvancedFiltersLabel = ({ title, changed, filled }) => {
  let label = <span style={{ padding: 2 }}>{title}</span>;

  if (filled) {
    label = (
      <Badge color={changed ? 'warning' : 'error'} variant={'dot'}>
        {label}
      </Badge>
    );
  }

  return label;
};
